import createHistory from 'history/createBrowserHistory';
export const history = createHistory();
export const jump = (url, search?, state?) => {
  history.push({
    pathname: url,
    search,
    state
  });
};
export default history;